import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RegistrationService {
  private organizationName: string | null = null;

  setOrganizationName(name: string): void {
    this.organizationName = name;
  }

  getOrganizationName(): string | null {
    return this.organizationName;
  }
}
